module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo1-d6fb867aba2281206f361755af76d5cc.png";